import { unref as f } from "vue";
const m = ["INPUT", "SELECT", "BUTTON"], u = 100, r = 8;
async function b(a, n) {
  var s, c, l;
  let o = 0;
  for (; o < r; ) {
    let t = f(a);
    if (t) {
      const e = document.activeElement;
      if (e) {
        if (e === t) break;
        if (m.indexOf(e.tagName) !== -1) {
          const d = (s = e.attributes.getNamedItem("disabled")) == null ? void 0 : s.value;
          if (!(d != null)) {
            const i = e.getBoundingClientRect();
            if (i && i.top >= 0 && i.left >= 0 && i.bottom <= (window.innerHeight || document.documentElement.clientHeight) && i.right <= (window.innerWidth || document.documentElement.clientWidth))
              break;
          }
        }
      }
      (c = t.shadowRoot) != null && c.firstElementChild && "focus" in ((l = t.shadowRoot) == null ? void 0 : l.firstElementChild) && t.shadowRoot.firstElementChild.focus(), t && "focus" in t && (t.focus(), n && n(t));
    }
    o += 1, await new Promise((e) => setTimeout(e, u));
  }
}
export {
  b as a
};
//# sourceMappingURL=autoFocus-CVmVp5SB.js.map
